import React from "react";
import "./tax.css";
import { Button } from "@chakra-ui/react";
import { PlusSquareIcon } from "@chakra-ui/icons";

const TaxContract = ({ formValues, setFormValues }) => {
  return (
    <div className="tax-contract-main">
      <div className="part-one">
        <div className="icon-div">
          <img src="tax.png" alt="" />
        </div>
        <div className="texts-div">
          <p>Contract Summary</p>
          <h4>Tax Contract</h4>
        </div>
      </div>
      <div className="part-two">
        <p>
          The smart contract complies with the standard ERC20-BEP20 scheme.
          Liquidity and Marketing fee options are available.
        </p>
      </div>
      <div className="part-three">
        <div className="text">Token Name</div>
        <div className="result">
          {formValues.tokenName.trim("") === "" ? "-" : formValues.tokenName}
        </div>
        <div className="text">Total Supply</div>
        <div className="result">
          {formValues.tokenTotalSupply.trim("") === ""
            ? "-"
            : formValues.tokenTotalSupply}
        </div>
        <div className="text">Buy Tax</div>
        <div className="result">{formValues.liqFee + formValues.marketingFee}</div>
        <div className="text">Sell Tax</div>
        <div className="result">{formValues.liqFee2 + formValues.marketingFee2}</div>
        <div className="text">Liquidity Proportion</div>
        <div className="result">
          {formValues.liquidityProportion.toString().trim("") === ""
            ? "-"
            : formValues.liquidityProportion}
        </div>
        <div className="text">Native Liquidity</div>
        <div className="result">
          {formValues.nativeLiquid.toString().trim("") === ""
            ? "-"
            : formValues.nativeLiquid}
        </div>
        <div className="text">Lp Lock</div>
        <div className="result">
          {formValues.lockedFor.trim("") === "" ? "-" : formValues.lockedFor}
        </div>
        <div className="text">Anti - Whale</div>
        <div className="result">
          {formValues.antiWhale === true ? (
            <img src="tick.png" alt="" />
          ) : (
            <img src="cross.png" alt="" />
          )}
        </div>
        <div className="text">Anti Bot GWEI</div>
        <div className="result">
          {formValues.antiBot === true ? (
            <img src="tick.png" alt="" />
          ) : (
            <img src="cross.png" alt="" />
          )}
        </div>
        <div className="text">Anti Bot Block</div>
        <div className="result">
          {formValues.antiBotBlock === true ? (
            <img src="tick.png" alt="" />
          ) : (
            <img src="cross.png" alt="" />
          )}
        </div>
        <div className="text">Start Trading?</div>
        <div className="result">
          {formValues.openTrade === true ? (
            <img src="tick.png" alt="" />
          ) : (
            <img src="cross.png" alt="" />
          )}
        </div>
      </div>
      <div className="part-four">
        <Button
          leftIcon={<PlusSquareIcon />}
          colorScheme="blue"
          variant="solid"
        >
          Create Token
        </Button>
      </div>
      <hr />
      <div className="part-five">
        <p>
          We DO NOT accept any liability for any loss caused by anyone acting or
          refraining from taking action as a result of any service provided.
        </p>
      </div>
    </div>
  );
};

export default TaxContract;
